export const second = 1000;
export const minute = 60 * second;
export const hour = minute * 60;

export const kByte = 1024;
export const MByte = kByte * 1024;
export const GByte = MByte * 1024;

export const CPU_NUMS = 'cpus_detected_num';
export const ALL_CPU_USAGE = 'cpu_usage_percent';
export const MEMORY_WORKING_SET = 'memory_working_set_bytes';
export const MEMORY_TOTAL = 'memory_total_bytes';
export const EACH_GPU_USAGE_PREFIX = 'gpu_util_percent_gpu';
export const EACH_GPU_MEMORY_USAGE_PREFIX = 'gpu_memory_usage_bytes_gpu';
export const EACH_GPU_MEMORY_TOTAL = 'gpu_memory_total_bytes';
